import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSignOutAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 17 14"
    {...props}
  >
    <path
      fill="#4B7EFF"
      d="M8.5 2.5c0-1.312 1.594-2 2.531-1.062l4.5 4.5c.594.593.594 1.562 0 2.125l-4.5 4.5c-.937.937-2.531.28-2.531-1.063V9.906h-3a1.5 1.5 0 0 1-1.5-1.5V5.625a1.5 1.5 0 0 1 1.5-1.5h3zm6 4.5L10 2.5v3.125H5.5v2.781H10V11.5zM3 1h2.625c.188 0 .375.188.375.375v.75a.38.38 0 0 1-.375.375H3A1.5 1.5 0 0 0 1.5 4v6c0 .844.656 1.5 1.5 1.5h2.625c.188 0 .375.188.375.375v.75a.38.38 0 0 1-.375.375H3a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3"
    />
  </svg>
);
export default SvgSignOutAlt;
